import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import eclLogo from "../assets/ecl-logo-svg-white.svg";

import "./NavbarStyles.css";

const Navbar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const [color, setColor] = useState(false);
  
  useEffect(() => {
    const changeColor = () => {
      if (window.scrollY >= 100) {
        setColor(true);
      } else {
        setColor(false);
      }
    };

    window.addEventListener("scroll", changeColor);
    
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("scroll", changeColor);
    };
  }, []);

  return (
    <div className={color ? "header header-bg" : "header"}>
      <div className="header-title">
        <a href="https://www.eastcoastlandscapes.ca/" className="header-link">
          <img className="header-title-logo" src={eclLogo} alt="East Coast Landscapes Logo" />
          <span className="header-title-text">
            EastCoastLandscapes.ca
          </span>
        </a>
      </div>

      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link to="/" onClick={() => setClick(false)}>Home</Link>
        </li>
        <li>
          <Link to="/services" onClick={() => setClick(false)}>Services</Link>
        </li>
        <li>
          <Link to="/contact" onClick={() => setClick(false)}>Contact</Link>
        </li>
      </ul>

      <div className="hamburger" onClick={handleClick}>
        {click ? (
          <FaTimes size={30} style={{ color: "#fff" }} />
        ) : (
          <FaBars size={30} style={{ color: "#fff" }} />
        )}
      </div>
    </div>
  );
};

export default Navbar;
